module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [(_vm.user) ? _c('h4', [_vm._v("\n        Welcome,   " + _vm._s(_vm.user.email) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n        Membership Type:\n        "), _c('b', [_vm._v(_vm._s(_vm.user && _vm.user.premium ? "Premium" : "Free"))])]), _vm._v(" "), (_vm.user && _vm.user.premium) ? _c('div', [_c('p', [_vm._v("\n          Email: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("\n          Pick Notifications:\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyEmail),
      expression: "notifyEmail"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyEmail) ? _vm._i(_vm.notifyEmail, null) > -1 : (_vm.notifyEmail)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.notifyEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyEmail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyEmail = $$c
        }
      }
    }
  }), _vm._v("\n            Email\n          ")]), _vm._v(" "), (_vm.notifyEmail) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }],
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Contact Email"
    },
    domProps: {
      "value": _vm._s(_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyPush),
      expression: "notifyPush"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyPush) ? _vm._i(_vm.notifyPush, null) > -1 : (_vm.notifyPush)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.notifyPush,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyPush = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyPush = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyPush = $$c
        }
      }
    }
  }), _vm._v("\n            Push Notification\n          ")]), _vm._v(" "), (_vm.notifyPush) ? _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#666",
      "margin": "4px 0 0 24px"
    }
  }, [_vm._v("\n            Visit "), _c('a', {
    staticStyle: {
      "color": "#e94560"
    },
    attrs: {
      "href": "https://m.stumpthespread.com/myaccount",
      "target": "_blank"
    }
  }, [_vm._v("StumptheSpread.com/myaccount")]), _vm._v(" on your phone to set up push notifications.\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.user.notify_sms || _vm.user.contact_method === 2) ? _c('div', {
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifySms),
      expression: "notifySms"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifySms) ? _vm._i(_vm.notifySms, null) > -1 : (_vm.notifySms)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.notifySms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifySms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifySms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifySms = $$c
        }
      }
    }
  }), _vm._v("\n            Text Message\n          ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#999",
      "margin-left": "4px"
    }
  }, [_vm._v("(no longer available for new sign-ups — please use Push Notifications instead)")]), _vm._v(" "), (_vm.notifySms) ? _c('div', {
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "id": "phoneList",
      "name": "phones"
    },
    on: {
      "change": function($event) {
        _vm.phone = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.phoneOpts), function(p) {
    return _c('option', {
      key: p.value,
      domProps: {
        "value": p
      }
    }, [_vm._v("\n                " + _vm._s(p.key) + "\n              ")])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactPhone),
      expression: "contactPhone"
    }],
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Contact Phone"
    },
    domProps: {
      "value": _vm._s(_vm.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactPhone = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.user.premium) ? _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n        Upgrade\n      ")]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.premium) ? _c('button', {
    staticClass: "big-btn orange",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_vm._v("\n        Update\n      ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn blue",
    attrs: {
      "to": {
        path: '/changepassword'
      }
    }
  }, [_vm._v("\n        Change Password\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05fd5457!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyAccount.vue
// module id = 480
// module chunks = 1